import {
  REQUEST_ASSIGNED_CLAIMS_BY_SUB_SERVICES,
  SET_ASSIGNED_CLAIMS_BY_SUB_SERVICES,
  REQUEST_ASSIGN_CLAIM_TO_MANAGER,
} from 'containers/CourtManagerAssignedClaims/constants';
import {
  AssignedClaimResponse,
  AssignClaimAction,
} from 'containers/CourtManagerAssignedClaims/typings';

export const requestAssignedClaimsBySubServices = (
  page: number,
  pageSize: number,
  step: string,
  procedureType: string,
  assignedManagerCode: number,
  isManager: boolean,
  isInboxesActive: boolean,
) => ({
  type: REQUEST_ASSIGNED_CLAIMS_BY_SUB_SERVICES,
  page,
  pageSize,
  step,
  procedureType,
  assignedManagerCode,
  isManager,
  isInboxesActive,
});

export const setAssignedClaimsBySubServices = (
  assignment: AssignedClaimResponse,
) => ({
  type: SET_ASSIGNED_CLAIMS_BY_SUB_SERVICES,
  assignment,
});

export const requestAssignClaimToManager = (
  payload: AssignClaimAction,
  successCallback: Function,
) => ({
  type: REQUEST_ASSIGN_CLAIM_TO_MANAGER,
  payload,
  successCallback,
});
